import { CatalogRenderer } from "@/components/catalogs/CatalogRenderer/CatalogRenderer";
import type { CatalogByPathMeta } from "@/lib/api/cms-catalog";
import type { CmsBackground } from "@/lib/api/cms-windows";
import type { FrontendUserSession } from "@/lib/api/session";
import styles from "./CatalogContentArea.module.css";

/**
 * CatalogContentArea — DEDYKOWANY obszar dla treści katalogu w catalog layouts.
 *
 * **NIE jest drop target!** Admin nie może tu wrzucać okien — content tej
 * sekcji pochodzi z zarządzania katalogiem w IADMIN (per `c_*` component).
 *
 * **Implementacja:** thin wrapper wokół `<CatalogRenderer>` (dispatcher per
 * `c_symbol` z fallback messages dla missing class/method/renderer). Wrapper
 * istnieje żeby layouty (`LCatalog*`) miały stabilny slot do wstawiania —
 * `CatalogRenderer` może się zmieniać niezależnie.
 *
 * @param title           `imp_cms_catalog.name` (lub `name_header` jeśli ustawione)
 * @param componentSymbol `imp_cms_component.symbol` (np. `c_descriptive_page`)
 * @param content         Payload z `C_*_CONTROLLER::getApiContent()` (per-typ)
 * @param meta            Backend meta flagi (missing_class/missing_method/...)
 */
export function CatalogContentArea({
  title,
  subtitle,
  componentSymbol,
  content,
  background,
  meta,
  userSession,
  containerSymbol,
}: CatalogContentAreaProps) {
  return (
    <div className={styles.viewMode}>
      <CatalogRenderer
        componentSymbol={componentSymbol}
        title={title}
        subtitle={subtitle ?? null}
        content={content}
        background={background}
        meta={meta}
        userSession={userSession ?? null}
        containerSymbol={containerSymbol ?? null}
      />
    </div>
  );
}

export type CatalogContentAreaProps = {
  title: string;
  /** Podtytuł renderowany pod h1 w kontenerze CDefault. Przekazany przez
      `CatalogLayoutRenderer` z `imp_cms_catalog.name_subtitle`. */
  subtitle?: string | null;
  componentSymbol: string | null;
  content: unknown;
  /** Tło katalogu z `imp_cms_catalog.config[background]` przez `m_site_backgrounds`. */
  background?: CmsBackground | null;
  meta?: CatalogByPathMeta;
  /** SSR-resolved user session — propagowane do c_* rendererów (np.
      `CUserAccounts`). NULL gdy visitor. */
  userSession?: FrontendUserSession | null;
  /** Symbol kontenera z `IAPI_catalogByPath.data.container_symbol` - mapowany
      w `CatalogRenderer` przez `resolveContainer` na `ContainerOverride`. */
  containerSymbol?: string | null;
};
